"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaneEffectLayer = exports.LaneEffect = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const Animation_1 = require("../../Common/Animation/Animation");
const Constants_1 = require("../../Core/Constants");
const GameState_1 = require("../../Core/GameState");
const GameConfig_1 = require("../../Core/GameConfig");
class LaneEffect extends pixi_js_1.Sprite {
    constructor(texture, flip = false) {
        super(texture);
        this.anim = new Animation_1.AnimationManager();
        this.anim.propSetter = Animation_1.CreatePixiPropSetter(this);
        this.anim.animations.set("scalex", {
            keyframes: [
                { time: 0, value: flip ? -1 : 1, type: "bezier", ctrl: [1, 0, 1, 1] },
                { time: 0.25, value: flip ? -0.4 : 0.4, type: "static" },
            ],
            totaltime: 0.25,
        });
        this.anim.animations.set("scaley", {
            keyframes: [
                { time: 0, value: 1, type: "bezier", ctrl: [1, 0, 1, 1] },
                { time: 0.25, value: 0.4, type: "static" },
            ],
            totaltime: 0.25,
        });
        this.anim.animations.set("alpha", {
            keyframes: [
                { time: 0, value: 0.8, type: "bezier", ctrl: [0.42, 0, 1, 1] },
                { time: 0.25, value: 0, type: "static" },
            ],
            totaltime: 0.25,
        });
        this.anim.onEnd.add(() => {
            this.visible = false;
        });
    }
    setAnim() {
        this.visible = true;
        this.anim.currentTime = 0;
    }
    update(dt) {
        if (!this.visible)
            return;
        this.anim.update(dt);
    }
}
exports.LaneEffect = LaneEffect;
let LaneEffectLayer = class LaneEffectLayer extends pixi_js_1.Container {
    constructor(resources, state, events, config) {
        super();
        if (!config.laneEffect)
            return;
        const list = [0.166, 0.23, 0.36, 0.5];
        const effects = [0, 1, 2, 3, 4, 5, 6].map(x => {
            const i = 3 - Math.abs(x - 3);
            const e = new LaneEffect(resources.game.textures["bg_line" + i], x > 3);
            e.y = Constants_1.LaneBottomY;
            e.x = Constants_1.LaneCenterXs[x];
            e.visible = false;
            e.anchor.set(list[i], 1);
            return e;
        });
        this.addChild(...effects);
        events.Update.add((remove, dt) => {
            if (state.ended)
                return remove();
            if (state.paused)
                return;
            for (const x of effects) {
                x.update(dt);
            }
        });
        state.on.judge.add((remove, n) => {
            if (n.judge !== "miss")
                effects[n.lane].setAnim();
        });
        state.on.emptyTap.add((remove, l) => {
            effects[l].setAnim();
        });
    }
};
LaneEffectLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, GameState_1.GameState, SymbolClasses_1.GlobalEvents, GameConfig_1.GameConfig])
], LaneEffectLayer);
exports.LaneEffectLayer = LaneEffectLayer;
//# sourceMappingURL=LaneEffectLayer.js.map